<template>
	<ja-modal :show="show" class="stage-modal">
		<div class="modal-header">
			<div class="title-wrapper">
				<h2 class="modal-title">{{ titleFirstPart }} {{ titleSecondPart }}</h2>
			</div>

			<ja-close-button
				class="close-button"
				name="close"
				@click.native="closeModalCompletedCategories"
			></ja-close-button>
		</div>
		<perfect-scrollbar class="categories-container">
			<div class="list-wrapper">
				<div
					v-for="category in completedItems"
					:key="category.id"
					class="list-element completed"
				>
					<svgicon
						v-if="category.assetName"
						:name="`${assetItemPath}${category.assetName}`"
					></svgicon>
					<div class="category-name body-text-1">
						{{ category.name }}
					</div>
					<div class="body-text-1">
						{{ $t('completed') }}
					</div>
				</div>
				<div
					v-for="category in incompletedItems"
					:key="category.id"
					class="list-element"
				>
					<svgicon
						v-if="category.assetName"
						:name="`${assetItemPath}${category.assetName}`"
					></svgicon>
					<div class="category-name body-text-1">
						{{ category.name }}
					</div>
				</div>
			</div>
		</perfect-scrollbar>
		<div class="bottom-modal">
			<ja-button
				name="done-modal"
				class="small"
				@click.native="closeModalCompletedCategories"
				>{{ $t('done') }}</ja-button
			>
		</div>
	</ja-modal>
</template>
<script>
import Modal from '@/components/Modal/Modal';
import Button from '@/components/ui/Button';
import CloseButton from '@/components/ui/CloseButton';

export default {
	components: {
		jaModal: Modal,
		jaButton: Button,
		jaCloseButton: CloseButton
	},
	props: {
		show: {
			type: Boolean,
			default: false
		},
		titleFirstPart: {
			type: String,
			default: ''
		},
		titleSecondPart: {
			type: String,
			default: ''
		},
		completedItems: {
			type: Array,
			default: null
		},
		incompletedItems: {
			type: Array,
			default: null
		},
		assetItemPath: {
			type: String,
			default: ''
		}
	},
	methods: {
		closeModalCompletedCategories() {
			this.$emit('closeModalCompletedCategories');
		}
	}
};
</script>
<style lang="scss" scoped>
.stage-modal {
	.modal-header {
		position: relative;
		width: 100%;
		border-bottom: 1px solid $button-border;

		.title-wrapper {
			display: inline-block;
			margin: 32px 0;
			width: 100%;
			text-align: center;
			vertical-align: middle;
			.modal-title {
				width: 80%;
				text-transform: capitalize;
				margin: auto;
			}
		}

		.close-button {
			bottom: 0;
			margin: auto;
		}
	}
	.categories-container {
		height: 400px;
		width: 100%;
		overflow-y: auto;

		.list-wrapper {
			width: 66%;
			margin: 32px auto;
			display: flex;
			flex-direction: column;

			.list-element {
				width: 100%;
				display: flex;
				align-items: center;

				&:not(:last-child) {
					margin-bottom: 16px;
				}

				&.completed {
					svg {
						color: $icon-read;
					}
				}

				.category-name {
					flex-grow: 1;
				}

				svg {
					height: 24px;
					width: 24px;
					margin-right: 16px;
					color: $font-blue;
				}
			}
		}
	}

	.bottom-modal {
		border-top: 1px solid $button-border;
		display: flex;
		justify-content: center;

		button {
			margin: 16px 0;
		}
	}
}
</style>
